<template>
  <div class="dialogs">
    <el-dialog :visible.sync="dialog.visible" width="30%" :close-on-click-modal="false" :append-to-body="true">
      <div class="close-icon" @click="handleClose"></div>
      <div class="title">{{ title }}</div>
      <div class="inner">
        <div class="common-form">
          <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="100px" class="demo-ruleForm">
            <el-row :gutter="20">
              <el-col :span="24" :offset="0">
                <el-form-item label="登录名" prop="loginName">
                  <el-input v-model="ruleForm.loginName" placeholder="请输入登录名"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24" :offset="0">
                <el-form-item label="用户名" prop="userName">
                  <el-input v-model="ruleForm.userName" placeholder="请输入用户名"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24" :offset="0">
                <el-form-item label="年龄" prop="age">
                  <el-input v-model.number="ruleForm.age" placeholder="请输入年龄"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24" :offset="0">
                <el-form-item label="手机号" prop="phone">
                  <el-input v-model="ruleForm.phone" placeholder="请输入手机号"></el-input>
                </el-form-item>
              </el-col>
              <el-col v-if="title==='新增用户'" :span="24" :offset="0">
                <el-form-item label="密码" prop="userPassword">
                  <el-input v-model="ruleForm.userPassword" type="password" placeholder="请输入密码"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24" :offset="0">
                <el-form-item label="是否启用" prop="state">
                  <el-switch
                    v-model="ruleForm.state"
                    :active-value="1"
                    :inactive-value="0"
                  >
                  </el-switch>
                </el-form-item>
              </el-col>
              <el-col :span="24" :offset="0">
                <el-form-item label="描述" prop="note">
                  <el-input v-model="ruleForm.note" type="textarea" placeholder="请输入账号描述"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
      <div class="btns">
        <div class="btn ensure-btn" @click="handleEnsure('ruleForm')">确定</div>
        <div class="btn close-btn" @click="handleClose">取消</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { addEditUser } from '@/api/user/index.js'
export default {
  name: 'UserDialogs',
  props: {
    dialogState: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      title: '',
      dialog: {
        visible: false,
        method: '',
        params: ''
      },
      ruleForm: {},
      rules: {
        loginName: [
          { required: true, message: '不能为空', trigger: 'blur' },
          { min: 3, message: '长度不得小于3', trigger: 'blur' },
          { pattern: /^[0-9a-zA-Z_]{1,}$/, message: '只能包含数字、字母及下划线' }
          //
        ],
        userName: [
          { required: true, message: '不能为空', trigger: 'change' },
          { max: 6, message: '长度不得大于6', trigger: 'blur' }
        ],
        age: [
          { required: true, message: '不能为空', trigger: 'change' },
          { pattern: /^(1[89]|[2-9]\d|100)$/, message: '请输入合适的年龄' }
          //
        ],
        phone: [
          { required: true, message: '不能为空', trigger: 'change' },
          { pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/, message: '请输入正确的手机号' }
        ],
        userPassword: [
          { required: true, message: '不能为空', trigger: 'change' },
          { pattern: /^[0-9a-zA-Z_]{1,}$/, message: '只能包含数字、字母及下划线' }

        ]
      }
    }
  },
  watch: {
    dialogState: {
      handler(newVal) {
        this.dialog = {
          visible: newVal.visible,
          method: newVal.method,
          params: newVal.params
        }
        if (this.dialog.method === 'edit') {
          this.title = '编辑用户'
          this.ruleForm = {
            loginName: this.dialog.params.loginName,
            userName: this.dialog.params.userName,
            age: this.dialog.params.age,
            note: this.dialog.params.note,
            phone: this.dialog.params.phone,
            createTime: this.dialog.params.createTime,
            id: this.dialog.params.id,
            state: this.dialog.params.state
          }
        } else {
          this.ruleForm = {
            loginName: '',
            userName: '',
            age: '',
            note: '',
            phone: '',
            userPassword: ''
          }
          this.title = '新增用户'
        }
        if (newVal.visible) {
          this.handleDialogState()
        }
      },
      deep: true
    }
  },
  created() {},
  methods: {
    handleClose() {
      this.ruleForm = {}
      this.dialogState.visible = false
    },
    handleEnsure(formName) {
      this.submitForm(formName)
    },
    handleDialogState() {
    },
    submitForm(formName) {
      this.$refs[formName].validate(async(valid) => {
        if (valid) {
          let url = ''
          let message = ''
          if (this.title === '新增用户') {
            this.ruleForm.createTime = this.moment().format('yyyy-MM-DD HH:mm:ss')
            url = '/user/save'
            message = '新增用户成功'
          } else {
            url = '/user/update'
            message = '更改用户信息成功'
          }
          const res = await addEditUser(url, this.ruleForm)
          if (res.code === 0) {
            this.$emit('refrush')
            this.ruleForm = {}
            this.$message({
              type: 'success',
              message
            })
            this.dialogState.visible = false
          }
        } else {
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    }
  }
}
</script>

<style scoped lang='scss'>
::v-deep .el-dialog__body{
  height: 640px;
  padding: 0;
  width: 700px;
  .el-textarea__inner{
    background-color: transparent;
    border: none;
    background: linear-gradient(0deg, #06DAF420 0%, rgba(0, 89, 86, 0.001) 51%, rgba(6, 218, 244, 0.18) 95%);
    height: 80px;
    border-radius: 1px;
    color: #fff;
  }
}
.inner{
  padding: 100px ;
}
</style>
